export default __webpack_public_path__ + "static/media/GreyRectangleLeftBigEllipse.2f3daaa7.svg";